/* RESPONSIBLE TEAM: team-proactive-support */
import { tracked } from '@glimmer/tracking';

interface SimpleOffset {
  x: number;
  y: number;
}

export { SimpleOffset };
export default class Offset {
  @tracked x: number;
  @tracked y: number;

  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }

  get isZero(): boolean {
    return this.x === 0 && this.y === 0;
  }
}
